import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'BreadcrumbList',
                itemListElement: [
                  {
                    '@type': 'ListItem',
                    position: 1,
                    name: '首页',
                    item: 'https://www.ky.app/',
                  },
                  {
                    '@type': 'ListItem',
                    position: 2,
                    name: '关于我们',
                    item: 'https://www.ky.app/about',
                  },
                ],
              },
              {
                '@type': 'Organization',
                name: 'KY App',
                url: 'https://www.ky.app',
                description: 'KY应用官方指定地址，提供最新版本极速下载、安全安装与账号注册服务。',
                email: 'support@ky.app',
                contactPoint: {
                  '@type': 'ContactPoint',
                  email: 'support@ky.app',
                  contactType: 'customer service',
                  availableLanguage: ['Chinese'],
                },
              },
              {
                '@type': 'WebPage',
                name: '关于 KY App — 品牌介绍与联系方式',
                description: '了解KY应用的品牌故事、核心团队、用户口碑及联系方式。www.ky.app 官方入口，提供安全稳定的移动应用体验。',
                url: 'https://www.ky.app/about',
              },
            ],
          }),
        }}
      />

      <Navbar />
      <main className="pt-16">
        {/* Page Header */}
        <section className="bg-background-100 py-14 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
                关于 KY App
              </h1>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                www.ky.app — 安全、稳定、值得信赖的移动应用官方平台
              </p>
            </div>
          </div>
        </section>

        {/* Brand Story */}
        <section className="py-16 md:py-24 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
                <div className="flex-1">
                  <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-5">
                    品牌故事
                  </h2>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                    KY App 诞生于对移动应用体验的极致追求。我们的创始团队由一群热爱技术、注重用户体验的工程师和设计师组成，怀着"让每个人都能享受流畅、安全的移动应用"的初心，打造了这款备受用户喜爱的产品。
                  </p>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                    自上线以来，KY App 始终坚持以用户为中心，不断迭代优化产品体验。我们深知，在数字化时代，用户对应用的期待不仅仅是功能齐全，更在于安全性、稳定性和流畅度。正因如此，我们将数据安全和隐私保护置于产品开发的核心位置。
                  </p>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    如今，KY App 已服务超过 500 万全球用户，覆盖 150 多个国家和地区。我们保持初心，持续通过 <strong>www.ky.app</strong> 官方渠道为用户提供最安全、最稳定的应用下载与更新服务。
                  </p>
                </div>
                <div className="flex-1">
                  <div className="w-full h-72 md:h-80 rounded-2xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20tech%20office%20workspace%20with%20warm%20coral%20accent%20wall%20and%20natural%20light%20from%20large%20windows%2C%20clean%20desk%20with%20laptop%20and%20design%20sketches%2C%20creative%20atmosphere%2C%20professional%20interior%20design%2C%20no%20people%2C%20editorial%20photography%20style%20with%20warm%20tones&width=800&height=600&seq=about-brand-ky-01&orientation=landscape"
                      alt="KY App 品牌故事"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Core Values */}
        <section className="py-16 md:py-24 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12 md:mb-16">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
                  核心价值
                </h2>
                <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
                  我们所坚持的原则，是 KY App 持续成长的基石
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {[
                  {
                    icon: 'ri-shield-star-line',
                    title: '安全第一',
                    desc: '采用行业领先的加密技术和多层安全防护，确保用户数据在传输和存储过程中的绝对安全。定期进行第三方安全审计。',
                  },
                  {
                    icon: 'ri-user-heart-line',
                    title: '用户至上',
                    desc: '始终从用户体验出发进行产品设计，倾听每一位用户的反馈，持续优化产品功能和使用流程。',
                  },
                  {
                    icon: 'ri-shake-hands-line',
                    title: '诚信透明',
                    desc: '坚持透明的隐私政策和数据使用说明，让用户清楚了解数据的使用方式，绝不滥用任何用户信息。',
                  },
                  {
                    icon: 'ri-rocket-line',
                    title: '持续创新',
                    desc: '保持技术敏感度和创新精神，不断引入新技术优化产品性能，为用户带来更好的使用体验。',
                  },
                  {
                    icon: 'ri-global-line',
                    title: '全球视野',
                    desc: '服务覆盖全球 150+ 国家和地区，支持多语言和多平台，让世界各地的用户都能享受优质服务。',
                  },
                  {
                    icon: 'ri-team-line',
                    title: '团队协作',
                    desc: '拥有一支充满激情的专业团队，来自不同领域的优秀人才共同为 KY App 的发展贡献力量。',
                  },
                ].map((item, idx) => (
                  <div key={idx} className="p-6 rounded-2xl bg-background-50">
                    <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 text-accent-500 mb-4">
                      <i className={`${item.icon} text-lg`}></i>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-900 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Reputation / Milestones */}
        <section className="py-16 md:py-24 bg-background-50">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12 md:mb-16">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
                  品牌信誉
                </h2>
                <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
                  用数字说话，见证 KY App 的成长与用户信赖
                </p>
              </div>

              {/* Timeline */}
              <div className="max-w-3xl mx-auto">
                {[
                  { year: '2020', title: '项目启动', desc: '创始团队组建，KY App 项目正式立项开发' },
                  { year: '2021', title: '首次发布', desc: 'KY App v1.0 正式上线 www.ky.app，支持 iOS 平台' },
                  { year: '2022', title: '百万用户', desc: '全球用户突破 100 万，上线 Android 版本，完成双平台覆盖' },
                  { year: '2023', title: '功能升级', desc: '推出多项核心功能升级，用户评分达到 4.8 分' },
                  { year: '2024', title: '全球化加速', desc: '全球用户突破 500 万，覆盖 150+ 国家和地区，持续优化体验' },
                ].map((item, idx) => (
                  <div key={idx} className="flex gap-5 pb-8 last:pb-0">
                    <div className="flex flex-col items-center">
                      <div className="w-3 h-3 rounded-full bg-accent-500 flex-shrink-0 mt-1.5"></div>
                      {idx < 4 && <div className="w-px flex-1 bg-background-300 mt-2"></div>}
                    </div>
                    <div className="pb-2">
                      <span className="text-xs font-semibold text-accent-600 bg-accent-100 px-2.5 py-0.5 rounded-full">
                        {item.year}
                      </span>
                      <h4 className="text-base font-semibold text-foreground-900 mt-2 mb-1">
                        {item.title}
                      </h4>
                      <p className="text-sm text-foreground-500 leading-relaxed">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-16 md:py-24 bg-background-100" id="contact">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12 md:mb-16">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
                  联系我们
                </h2>
                <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto leading-relaxed">
                  如果你有任何问题或建议，欢迎通过以下方式联系我们
                </p>
              </div>

              <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
                {/* Contact Info */}
                <div className="flex-1 space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 flex-shrink-0">
                      <i className="ri-mail-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h4>
                      <p className="text-sm text-foreground-500">support@ky.app</p>
                      <p className="text-xs text-foreground-400 mt-1">一般问题咨询请在邮件中详细描述，我们将在24小时内回复</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 flex-shrink-0">
                      <i className="ri-customer-service-2-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-1">在线客服</h4>
                      <p className="text-sm text-foreground-500">7 × 24 小时全天候在线</p>
                      <p className="text-xs text-foreground-400 mt-1">通过 KY App 内的"我的-联系客服"功能即可联系在线客服</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 flex-shrink-0">
                      <i className="ri-links-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-1">官方入口</h4>
                      <p className="text-sm text-foreground-500">www.ky.app</p>
                      <p className="text-xs text-foreground-400 mt-1">唯一官方指定下载地址，建议收藏保存</p>
                    </div>
                  </div>
                </div>

                {/* Contact Form */}
                <div className="flex-1">
                  <form
                    data-readdy-form="true"
                    action="https://readdy.ai/api/form/d9rglt4nlsngrm4lmbu0"
                    method="POST"
                    className="p-6 md:p-8 rounded-2xl bg-background-50 space-y-4"
                  >
                    <div>
                      <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        你的姓名 <span className="text-primary-500">*</span>
                      </label>
                      <input
                        id="contact-name"
                        name="name"
                        type="text"
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-100 transition-colors"
                        placeholder="请输入你的姓名"
                      />
                    </div>

                    <div>
                      <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        电子邮箱 <span className="text-primary-500">*</span>
                      </label>
                      <input
                        id="contact-email"
                        name="email"
                        type="email"
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-100 transition-colors"
                        placeholder="请输入你的电子邮箱"
                      />
                    </div>

                    <div>
                      <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        主题
                      </label>
                      <input
                        id="contact-subject"
                        name="subject"
                        type="text"
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-100 transition-colors"
                        placeholder="请输入咨询主题"
                      />
                    </div>

                    <div>
                      <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        留言内容 <span className="text-primary-500">*</span>
                      </label>
                      <textarea
                        id="contact-message"
                        name="message"
                        required
                        maxLength={500}
                        rows={4}
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-100 transition-colors resize-none"
                        placeholder="请输入你想咨询的内容（最多500字）"
                      ></textarea>
                    </div>

                    {/* Anti-spam honeypot */}
                    <div className="spambot-field">
                      <input
                        type="text"
                        name="phone_alt"
                        tabIndex={-1}
                        autoComplete="off"
                        aria-hidden="true"
                        readOnly
                      />
                    </div>

                    <button
                      type="submit"
                      className="w-full px-6 py-3 rounded-full bg-primary-500 text-white text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors duration-200"
                    >
                      发送留言
                    </button>
                    <p className="text-xs text-foreground-400 text-center mt-3">
                      提交即表示你同意我们的隐私政策和服务条款
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}